import {
  Button,
  Form,
  TextInput,
  PasswordInput,
} from "carbon-components-react";
import {
  Credentials32,
  FaceDissatisfied32,
  Help32,
  ArrowRight24,
} from "@carbon/icons-react";
import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import http from "../../http-common";
import { toast } from "react-toastify";
import { AuthContext } from "../../contexts/AuthContext";
import CancelButton from "../../components/Buttons/CancelButton";
import { RuleCancelled24 } from "@carbon/icons-react";
import SubmitButton from "../../components/Buttons/SubmitButton";

const requiredMessage = "Campo obrigatório";

const loginSchema = yup.object({
  username: yup.string().required(requiredMessage),
  password: yup.string().required(requiredMessage),
});

const HomePage = () => {
  const { authenticated, login } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(loginSchema) });
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    await login(data.username, data.password);
  };

  return (
    <div className="bx--row">
      <div className="bx--col-lg-8 content mt-3">
        <h4 className="pretitle emprega-green">Conecta Negócios</h4>
        <h1 className="title">Plataformas Digitais</h1>
        <p>
          O Projecto Conecta Negócios, no quadro do desenvolvimento de elementos
          facilitadores das ligações empresariais prevê o desenvolvimento de
          Plataformas Digitais destinadas a providenciar a informação sobre as
          oportunidades de negócios que o mercado oferece bem como, a informação
          sobre o acesso aos recursos financeiros.{" "}
        </p>
        <p>
          Estas informações permitirão que cada empresa possa identificar,
          avaliar e decidir sobre as oportunidades a perseguir sem depender de
          ligações pessoais para o acesso à informação e tenham a possibilidade
          de aceder à oferta dos serviços financeiros sempre que necessitarem na
          tomada de decisões de negócios.
        </p>
      </div>
      <div className="bx--col-lg-4">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Login</h3>
          </div>
          <div className="card-body">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <TextInput
                {...register("username")}
                id="username"
                labelText="Número de Telefone"
                placeholder=""
                maxLength={9}
              />
              <p className="field-error">{errors.username?.message}</p>
              <PasswordInput
                id="password"
                {...register("password")}
                labelText="Senha"
                placeholder=""
              />
              <p className="field-error">{errors.password?.message}</p>
              <Button
                type="submit"
                renderIcon={ArrowRight24}
                className="mt-2 btn-fluid"
              >
                Login
              </Button>
              <p style={{ color: "#000", paddingTop: "10px" }}>
                <Link to={"/esqueceu-a-senha"}>Esqueceu a senha?</Link>
              </p>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
